import { FC } from 'react';
import { ThresholdResult } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { ThresholdResult as Result } from '@agilelab/plugin-wb-governance-common';
import { Variant } from '@material-ui/core/styles/createTypography';

interface Task {
  value: number;
  thresholdResult?: Result;
  hasError: boolean;
}

const useStyles = makeStyles(
  theme => ({
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  }),
  { name: 'MetricHeader' },
);

interface Props {
  name: string;
  task: Task;
  style?: React.CSSProperties;
  titleVariant?: Variant;
}

export const MetricHeader: FC<Props> = ({
  name,
  task,
  style,
  titleVariant = 'h6',
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.header} style={style}>
      <ThresholdResult
        value={task.value || 0}
        result={task.thresholdResult}
        hasError={task.hasError}
        variant="reduced"
      />
      <Typography
        variant={titleVariant}
        style={{ fontWeight: '700', marginBottom: 0 }}
      >
        {name}
      </Typography>
    </Box>
  );
};
